// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + "LogoMakerLPLazyComponent" + "." + "b26f3ffa409652270de5" + ".js";
};